// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'conversationExpired.expired': 'This conversation has expired.',
};
